import { createSlice } from '@reduxjs/toolkit';

export const ExhibitorSlice = createSlice({
  name: 'exhibitors',
  initialState: {
    value: [],
  },
  reducers: {
    setExhibitors: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setExhibitors } = ExhibitorSlice.actions;
export default ExhibitorSlice.reducer;
